<template>
  <b-card v-bind="cardAttrs" no-body v-on="$listeners">
    <div class="card-header">
      <!-- Title & SubTitle -->
      <div>
        <b-card-title>{{ $attrs.title }}</b-card-title>
        <b-card-sub-title v-if="$attrs['sub-title']">
          {{ $attrs['sub-title'] }}
        </b-card-sub-title>
      </div>
      <!-- Right btn -->
      <div>
        <slot name="btns" />
        <feather-icon
          v-if="btnVisible"
          class="text-primary ml-1"
          style="cursor: pointer;"
          :icon="`${body_visible ? 'ChevronsUpIcon' : 'ChevronsDownIcon'}`"
          size="28"
          @click="body_visible = !body_visible"
        />
      </div>
    </div>
    <div class="pl-2 pr-2">
      <slot name="base" />
    </div>
    <b-card-body v-if="body_visible">
      <!-- Card Content -->
      <b-collapse
        v-model="body_visible"
        class="card-code"
        :visible="body_visible"
      >
        <slot />
      </b-collapse>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCardSubTitle,
  BCardBody,
  BCollapse,
} from 'bootstrap-vue'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import Prism from 'vue-prism-component'

export default {
  name: 'BCardBtn',
  components: {
    BCard,
    BCardTitle,
    BCardSubTitle,
    BCardBody,
    BCollapse,
  },
  inheritAttrs: false,
  props: {
    bodyVisible: {
      type: Boolean,
      default: false,
    },
    btnVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      body_visible: this.bodyVisible,
    }
  },
  computed: {
    cardAttrs() {
      const cardAttrs = JSON.parse(JSON.stringify(this.$attrs))
      delete cardAttrs.title
      delete cardAttrs['sub-title']
      return cardAttrs
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'bootstrap/scss/functions';
@import '~@core/scss/base/bootstrap-extended/variables';
@import 'bootstrap/scss/variables';
@import '~@core/scss/base/components/variables-dark';

.card-code {
  pre[class*='language-'] {
    margin: 0;
    max-height: 350px;
    border-radius: 0.5rem;
  }
}

.code-toggler {
  border-bottom: 1px solid transparent;

  &[aria-expanded='false'] {
    border-bottom-color: $primary;
  }
}

// HTML
.card {
  .card-header .heading-elements {
    position: static;
    background: red;
  }
}
</style>
